import { Heading, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

interface Props {
  title: string;
  mb?: string | number;
}

// Server-rendered H1 for crawlable list pages. Keep this outside `dynamic(..., { ssr: false })`
// so the heading is present in the initial HTML.
const SeoPageHeading = ({ title, mb = '24px' }: Props) => {
  const color = useColorModeValue('#000000', '#FFFFFF');

  return (
    <Heading
      as="h1"
      mb={ mb }
      color={ color }
      fontSize={{ base: '24px', lg: '24px' }}
      lineHeight={{ base: '31px', lg: '31px' }}
      fontWeight={ 700 }
      fontFamily="'Space Grotesk', var(--chakra-fonts-heading)"
    >
      { title }
    </Heading>
  );
};

export default SeoPageHeading;
